const TiposProducto = [
  { label: "Sin tipo", value: "Sin tipo" },
  { label: "Fisico", value: "Fisico" },
  { label: "Digital", value: "Digital" },
  { label: "Consumible", value: "Consumible" },
]

export default TiposProducto